/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import PeriodEntry, { displayStringFromFHIRPeriod } from "./PeriodEntry";
import ArrayEntry from "./ArrayEntry";
import CodeableConceptEntry, { DisplayFromFHIRCodeableConcept } from "./CodeableConceptEntry";
import ReferenceEntry, { DisplayFromFHIRReference } from "./ReferenceEntry";
import AddressEntry, { displayStringFromFHIRAddress } from "./AddressEntry";
import { displayStringFromFHIRHumanName } from "./HumanNameEntry";
import ExpandToAddOrEdit from "../components/ExpandToAddOrEdit";

const ContactPointDisplay = ({ contactPoint }) => {
  if (contactPoint) {
    if (Array.isArray(contactPoint) || typeof contactPoint !== "object") {
      return <>[ERROR: ContactPoint data not interpretable.]</>;
    }
    return <div style={{ marginLeft: "24px" }}>
      {contactPoint.system && <p><b>Contact Type: </b>{contactPoint.system} </p>}
      {contactPoint.value && <p><b>Detail: </b>{contactPoint.value} </p>}
      {contactPoint.use && <p><b>Use: </b>{contactPoint.use} </p>}
      {contactPoint.period && <p><b>Period: </b>{displayStringFromFHIRPeriod(contactPoint.period)} </p>}
    </div>
  } else {
    return <></>
  }
}

const DisplayFromFHIRExtendedContactDetail = ({ extendedContactDetail }) => {
  if (extendedContactDetail) {
    if (Array.isArray(extendedContactDetail) || typeof extendedContactDetail !== "object") {
      return <>[ERROR: ExtendedContactDetail data not interpretable.]</>;
    }

    return <div>
      {extendedContactDetail.purpose && <><b>Purpose: </b><DisplayFromFHIRCodeableConcept codeableConcept={extendedContactDetail.purpose} /></>}
      {Array.isArray(extendedContactDetail.name) && extendedContactDetail.name.map((name, nameIndex) => {
        return <div key={nameIndex}><p><b>Contact Name: </b>{displayStringFromFHIRHumanName(name)}</p></div>
      })}
      {Array.isArray(extendedContactDetail.telecom) && extendedContactDetail.telecom.map((telecom, telecomIndex) => {
        return <div key={telecomIndex}><p><b>Contact Method: </b></p><ContactPointDisplay contactPoint={telecom} /><br /></div>
      })}
      {(extendedContactDetail.telecom && !Array.isArray(extendedContactDetail.telecom)) && <>[ERROR: extendedContactDetail.telecom is not in expected JSON form (should be an array).]</>}
      {extendedContactDetail.address && <p><b>Address: </b>{displayStringFromFHIRAddress(extendedContactDetail.address)}</p>}
      {extendedContactDetail.organization && <><b>Organization: </b><DisplayFromFHIRReference reference={extendedContactDetail.organization} /></>}
      {extendedContactDetail.period && <p><b>Period: </b>{displayStringFromFHIRPeriod(extendedContactDetail.period)}</p>}
    </div>
  } else {
    return <></>
  }
}

const ExtendedContactDetailEntry = ({ elementName, fieldLabel, startingValue, setResourceState, startCollapsed }) => {

  const [extendedContactDetailState, setExtendedContactDetailState] = useState({});
  const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

  useEffect(() => {
    let startingExtendedContactDetail = {
      "purpose": "", "name": [], "telecom": [], "address": "",
      "organization": "", "period": ""
    };
    if (startingValue) {
      if (startingValue.extension) { startingExtendedContactDetail.extension = startingValue.extension; }
      if (startingValue.purpose) { startingExtendedContactDetail.purpose = startingValue.purpose; }
      if (startingValue.name) { startingExtendedContactDetail.name = startingValue.name; }
      if (startingValue.telecom) { startingExtendedContactDetail.telecom = startingValue.telecom; }
      if (startingValue.address) { startingExtendedContactDetail.address = startingValue.address; }
      if (startingValue.organization) { startingExtendedContactDetail.organization = startingValue.organization; }
      if (startingValue.period) { startingExtendedContactDetail.period = startingValue.period; }
    }
    setExtendedContactDetailState(JSON.parse(JSON.stringify(startingExtendedContactDetail)));
  }, []);

  useEffect((() => {
    if (Object.keys(extendedContactDetailState).length) {
      let newContactDetail = {};
      if (extendedContactDetailState.extension) { newContactDetail.extension = extendedContactDetailState.extension; }
      if (extendedContactDetailState.purpose) { newContactDetail.purpose = extendedContactDetailState.purpose; }
      if (extendedContactDetailState.name !== null && extendedContactDetailState.name !== undefined &&
        Array.isArray(extendedContactDetailState.name) && extendedContactDetailState.name.length !== 0 &&
        !(extendedContactDetailState.name.length === 1 && Object.keys(extendedContactDetailState.name[0]).length === 0)) {
        newContactDetail.name = extendedContactDetailState.name;
      }
      if (extendedContactDetailState.telecom !== null && extendedContactDetailState.telecom !== undefined &&
        Array.isArray(extendedContactDetailState.telecom) && extendedContactDetailState.telecom.length !== 0 &&
        !(extendedContactDetailState.telecom.length === 1 && Object.keys(extendedContactDetailState.telecom[0]).length === 0)) {
        newContactDetail.telecom = extendedContactDetailState.telecom;
      }
      if (extendedContactDetailState.address) { newContactDetail.address = extendedContactDetailState.address; }
      if (extendedContactDetailState.organization) { newContactDetail.organization = extendedContactDetailState.organization; }
      if (extendedContactDetailState.period) { newContactDetail.period = extendedContactDetailState.period; }
      if (Object.keys(newContactDetail).length === 0) {
        newContactDetail = null;
      }
      setResourceState(prevState => { return { ...prevState, [elementName]: newContactDetail } });
    }
  }), [extendedContactDetailState]);

  if (startCollapsedState) {
    return <>
      <div>
        <b>{fieldLabel}: </b>
        {startingValue && <DisplayFromFHIRExtendedContactDetail contactDetail={startingValue} />}
        &nbsp;&nbsp;
        <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
      </div>
    </>
  } else if (Object.keys(extendedContactDetailState).length > 0) {
    return <div>
      <p style={{ marginBottom: "2px" }}><b>{fieldLabel}: </b></p>
      <div style={{ marginLeft: "24px" }}>
        <CodeableConceptEntry elementName='purpose' fieldLabel='Purpose' startCollapsed
          startingValue={extendedContactDetailState.purpose} setResourceState={setExtendedContactDetailState} />
        <ArrayEntry datatype='HumanName' elementName='name' startCollapsed={true}
          startEmptyArrayClosed={true}
          fieldLabel='Contact Name' startingValue={extendedContactDetailState.name} setResourceState={setExtendedContactDetailState} />
        <ArrayEntry datatype='ContactPoint' elementName='telecom' startCollapsed={true}
          startEmptyArrayClosed={true}
          fieldLabel='Contact Point' startingValue={extendedContactDetailState.telecom} setResourceState={setExtendedContactDetailState} />
        <AddressEntry elementName='address' fieldLabel='Address' startCollapsed
          startingValue={extendedContactDetailState.address} setResourceState={setExtendedContactDetailState} />
        <ReferenceEntry elementName='organization' fieldLabel='Organization' enableCreation startCollapsed
          startingResourceType="Organization"
          startingValue={extendedContactDetailState.organization} setResourceState={setExtendedContactDetailState} />
        <PeriodEntry elementName='period' fieldLabel='Period' startCollapsed
          startingValue={extendedContactDetailState.period} setResourceState={setExtendedContactDetailState} />
      </div>
    </div>
  }
}

export default ExtendedContactDetailEntry;
export { DisplayFromFHIRExtendedContactDetail };